import { DATE_YYYY_MM_DD } from "common/components/FilterMenu/constants"
import { formatDate } from "common/utils/date"
import { withFormik } from "formik"
import { TFunction } from "i18next"
import moment from "moment"
import * as Yup from "yup"
import RemesaForm from "./form"

interface NewRemesaFormValues {
  fechaVencimiento?: string | null
  concepto?: string | null
  cuentaBancariaId?: string | null
  identificador?: string | null
  facturasIds?: string[] | never[] | null
  tipo?: number | null
  tipoFlujoTesoreria?: number | null
}

export interface NewRemesaFormData extends NewRemesaFormValues {
  total: number | null
}

interface NewRemesaFormProps {
  hideModal?: () => void
  onHide?: () => void
  handleCreate?: (payload: NewRemesaFormValues) => void
  data: NewRemesaFormData
  t?: TFunction
}

let initialValues: NewRemesaFormValues = {
  fechaVencimiento: null,
  concepto: null,
  cuentaBancariaId: null,
  identificador: null,
  facturasIds: [],
  tipo: null,
  tipoFlujoTesoreria: null,
}

const mapPropsToValues = (data: NewRemesaFormData) => ({
  fechaVencimiento:
    moment(data?.fechaVencimiento).format("YYYY-MM-DD") ||
    moment(Date.now()).format("YYYY-MM-DD"),
  concepto: data?.concepto ?? "",
  cuentaBancariaId: data?.cuentaBancariaId ?? "",
  identificador: data?.identificador ?? "",
  facturasIds: data?.facturasIds ?? [],
  tipo: data?.tipo ?? null,
  tipoFlujoTesoreria: data?.tipoFlujoTesoreria ?? null,
})

const validationSchema = (t: TFunction) =>
  Yup.object().shape({
    fechaVencimiento: Yup.date().required(
      t("errors.dateRequired") ?? undefined
    ),
    concepto: Yup.string().required(t("errors.selectedOnePlease") ?? undefined),
    cuentaBancariaId: Yup.string().required(
      t("errors.selectedOnePlease") ?? undefined
    ),
    identificador: Yup.string().required(t("errors.addId") ?? undefined),
    operationType: Yup.number().nullable(),
    facturaIds: Yup.array(),
  })

const validateFechaVencimiento = (
  t?: TFunction,
  values?: NewRemesaFormValues
) => {
  let errors = {}
  const dateHasChanged =
    initialValues.fechaVencimiento !== values?.fechaVencimiento
  const dateIsInPastOrPresent = moment(
    new Date(values?.fechaVencimiento as string)
  ).isSameOrBefore(formatDate(Date.now(), DATE_YYYY_MM_DD))

  if (dateHasChanged && dateIsInPastOrPresent) {
    errors = {
      ...errors,
      fechaVencimiento: `${t?.("errors.currentDateImposible")}`,
    }
  }

  return errors
}

const NewRemesaForm = withFormik<NewRemesaFormProps, NewRemesaFormValues>({
  validateOnChange: true,
  validateOnBlur: true,
  validate: (rowData, { t }) => validateFechaVencimiento(t, rowData),
  mapPropsToValues: ({ data }) => {
    initialValues = mapPropsToValues(data)

    return initialValues
  },
  validationSchema: ({ t }: { t: TFunction }) => validationSchema(t),

  handleSubmit: async (values, { props }) => {
    const modifiedValues = {
      concepto: values?.concepto,
      cuentaBancariaId: values?.cuentaBancariaId,
      identificador: values?.identificador,
      facturaIds: props?.data.facturasIds,
      fechaVencimiento: values?.fechaVencimiento,
      tipoFlujoTesoreria: props?.data.tipo || null,
    }
    props.handleCreate?.(modifiedValues)
  },
})(RemesaForm)

export default NewRemesaForm
